<template>
  <header
    :class="{
      desktop: isDesktop,
      mobile: isMobile,
    }"
  >
    <AboutUs class="page-header" v-if="page === 'AboutUs'" />
    <!-- <Features
      class="page-header"
      v-if="page === 'Features' && tab === 'suck-customer-tool'"
    />
    <Features2
      class="page-header"
      v-if="page === 'Features' && tab === 'remain-customer-tool'"
    />
    <Features3
      class="page-header"
      v-if="page === 'Features' && tab === 'shop-manage-tool'"
    /> -->
    <Features4
      class="page-header-style bg-style"
      v-if="page === 'Features' && tab === 'reservations'"
    />
    <Features5
      class="page-header-style bg-style"
      v-if="page === 'Features' && tab === 'line-recruit'"
    />
    <Features6
      class="page-header-style bg-style"
      v-if="page === 'Features' && tab === 'promotions'"
    />
    <Features7
      class="page-header-style bg-style-1"
      v-if="page === 'Features' && tab === 'store-management'"
    />
    <Features8
      class="page-header-style bg-style"
      v-if="page === 'Features' && tab === 'grasp-repurchasers'"
    />
    <Features9
      class="page-header-style bg-style-2"
      v-if="page === 'Features' && tab === 'payment-method'"
    />
    <Features10
      class="page-header-style bg-style-2"
      v-if="page === 'Features' && tab === 'e-commerce-business'"
    />
    <Features11
      class="page-header-style bg-style-2"
      v-if="page === 'Features' && tab === 'device-space-management'"
    />
    <Industrial1 
      class="page-header-style bg-style-2"
      v-if="page === 'IndustrialApplication' && tab === 'nail-salon'"
    />
    <Industrial2 
      class="page-header-style bg-style-2"
      v-if="page === 'IndustrialApplication' && tab === 'eyelash-salon'"
    />
    <Industrial3 
      class="page-header-style bg-style-2"
      v-if="page === 'IndustrialApplication' && tab === 'beauty-salon'"
    />
    <Industrial4 
      class="page-header-style bg-style-2"
      v-if="page === 'IndustrialApplication' && tab === 'SPA-massage'"
    />
    <Industrial5 
      class="page-header-style bg-style-2"
      v-if="page === 'IndustrialApplication' && tab === 'hair-salon'"
    />
    <Industrial6
      class="page-header-style bg-style-2"
      v-if="page === 'IndustrialApplication' && tab === 'aesthetic-medicine'"
    />
    <Industrial7 
      class="page-header-style bg-style-2"
      v-if="page === 'IndustrialApplication' && tab === 'beautiful-breast'"
    />
    <Industrial8 
      class="page-header-style bg-style-2 bg-tablet-pr0"
      v-if="page === 'IndustrialApplication' && tab === 'hair-removal'"
    />
    <Industrial9 
      class="page-header-style bg-style-2"
      v-if="page === 'IndustrialApplication' && tab === 'makeup-artist'"
    />
    <Industrial10 
      class="page-header-style bg-style-2"
      v-if="page === 'IndustrialApplication' && tab === 'eyebrow-tattoo'"
    />
    <Industrial11 
      class="page-header-style bg-style-2"
      v-if="page === 'IndustrialApplication' && tab === 'teeth-whitening'"
    />
    <Industrial12 
      class="page-header-style bg-style-2"
      v-if="page === 'IndustrialApplication' && tab === 'mental-therapy'"
    />
    <Industrial13 
      class="page-header-style bg-style-2"
      v-if="page === 'IndustrialApplication' && tab === 'stay-fit'"
    />
    <Industrial14 
      class="page-header-style bg-style-2"
      v-if="page === 'IndustrialApplication' && tab === 'yoga-course'"
    />
    <SMSReservation class="page-header" v-if="page === 'SMSReservation'" />
    <MediaMarketing class="page-header" v-if="page === 'MediaMarketing'" />
    <PlanContent class="page-header" v-if="page === 'PlanContent'" />
  </header>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { useWindowSize } from '@vueuse/core'
import { computed } from '@vue/reactivity'
import AboutUs from './components/AboutUs.vue'
// import Features from './components/Features.vue'
// import Features2 from './components/Features2.vue'
// import Features3 from './components/Features3.vue'
import Features4 from './components/Features4.vue'
import Features5 from './components/Features5.vue'
import Features6 from './components/Features6.vue'
import Features7 from './components/Features7.vue'
import Features8 from './components/Features8.vue'
import Features9 from './components/Features9.vue'
import Features10 from './components/Features10.vue'
import Features11 from './components/Features11.vue'
import Industrial1 from './components/Industrial1.vue'
import Industrial2 from './components/Industrial2.vue'
import Industrial3 from './components/Industrial3.vue'
import Industrial4 from './components/Industrial4.vue'
import Industrial5 from './components/Industrial5.vue'
import Industrial6 from './components/Industrial6.vue'
import Industrial7 from './components/Industrial7.vue'
import Industrial8 from './components/Industrial8.vue'
import Industrial9 from './components/Industrial9.vue'
import Industrial10 from './components/Industrial10.vue'
import Industrial11 from './components/Industrial11.vue'
import Industrial12 from './components/Industrial12.vue'
import Industrial13 from './components/Industrial13.vue'
import Industrial14 from './components/Industrial14.vue'
import SMSReservation from './components/SMSReservation.vue'
import MediaMarketing from './components/MediaMarketing.vue'
import PlanContent from './components/PlanContent.vue'

const { width } = useWindowSize()

const isDesktop = computed(() => {
  return width.value > 768
})
const isMobile = computed(() => {
  return width.value < 768
})

const route = useRoute()

const page = computed(() => route.name)
const tab = computed(() => route.params.name)
</script>

<style scoped lang="postcss">
.page-header {
  @apply bg-center bg-cover bg-no-repeat mb-[48px];
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.13);
  &.about-us {
    background-size: auto 85%, auto 100%;
    background-position: center right 97px, top right;
    background-color: rgb(252 251 255);
    @screen <desktop {
      background-size: auto 80%, auto 100%;
      background-position: center right 50px, top right;
    }

    @screen <ipad {
      background-size: auto 58%, auto 100%;
      background-position: top 28px right 20px, top right;
    }
  }
}
.page-header-style {
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.13);
  &.features {
    @apply h-[611px] w-full bg-right bg-no-repeat;
    background-color: rgb(252, 251, 255);
  }
  &.mobile {
    @apply h-[408px];
  }
}
.bg-style {
  &.desktop {
    background-size: auto 80%, auto 100%;
    background-position: center right 50px, top right;
  }
  
  &.mobile {
    background-size: auto 80%, cover;
    background-position: bottom right 50px, top right;
    
    @screen <tablet {
      background-size: auto 60%, cover;
      background-position: bottom right 20px, top right;
    }
  }
}
.bg-style-1 {
  &.desktop {
    background-size: auto 50.74%, auto 100%;
    background-position: center right 50px, top right;
  }
  
  &.mobile {
    background-size: auto 65%, cover;
    background-position: bottom right, top right;
    
    @screen <tablet {
      background-size: auto 50%, cover;
      background-position: bottom 20% right, top right;
    }
  }
}
.bg-style-2 {
  &.desktop {
    background-size: auto 75%, auto 100%;
    background-position: center right 50px, top right;
  }
  
  &.mobile {
    background-size: auto 65%, cover;
    background-position: bottom right, top right;
    
    @screen <tablet {
      background-size: auto 63%, cover;
      background-position: bottom center, top right;
      &.bg-tablet-pr0 {
        background-position: bottom right, top right;
      }
    }
  }
}
.desktop {
  @apply rounded-bl-[200px];
}
.mobile {
  @apply rounded-bl-[60px];
}
</style>
